import React, { useState } from "react";
import ReactHtmlParser from "react-html-parser";

interface Props {
  selectedAnswer: any;
  question: any;
  answer: any;
  updateSelectedAnswer: (val: any) => void;
  submitAnswer: (e) => void;
  submitting: boolean;
  loadingAnswer: boolean;
  currentUser?: any;
}

const Choice: React.FC<Props> = ({
  question,
  answer,
  selectedAnswer,
  updateSelectedAnswer,
  submitAnswer,
  submitting,
  loadingAnswer,
  currentUser,
}) => {
  const [feedback, setFeedback] = useState("");

  const handleSubmit = (e) => {
    if (!selectedAnswer) {
      e.preventDefault();
      setFeedback("Choose an answer before submitting.");
      return;
    }

    submitAnswer(e);
  };

  const renderField = (option, i, answer) => {
    const translation = option?.translations?.find(
      (t) => t.language === currentUser?.locale,
    );

    if (!answer || option.id == answer?.answer_option_id) {
      return (
        <label key={i}>
          <input
            type="radio"
            name="radioGroup"
            value={option.id}
            checked={
              option.id == answer?.answer_option_id ||
              option.id == selectedAnswer
            }
            onChange={() => {
              setFeedback("");
              updateSelectedAnswer(option.id);
            }}
            disabled={!!answer}
          />
          <span>
            {ReactHtmlParser(
              translation?.formatted_content || option.formatted_content,
            )}
          </span>
        </label>
      );
    }
  };

  const translation = question?.translations?.find(
    (t) => t.language === currentUser?.locale,
  );

  return (
    <form className="q-card assignment-form">
      <div className="q-row">
        <span className="q-badge">Q</span>
        <div className="q-text">
          {ReactHtmlParser(
            translation
              ? translation?.formatted_description
              : question?.formatted_description,
          )}
        </div>
      </div>
      <div className="q-row q-answer">
        {(loadingAnswer || submitting) && (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        )}
        <span className="q-badge a">A</span>
        <div className="mcq" role="radiogroup" aria-label="Choose one answer">
          {question?.answer_options.map((option, i) =>
            renderField(option, i, answer),
          )}
        </div>
      </div>
      {!answer && (
        <div className="q-actions">
          <span className={`q-feedback ${feedback ? "no" : ""}`}>
            {feedback}
          </span>
          <button
            className={`btn btn-blue btn--compact ${
              submitting ? "loading" : ""
            }`}
            type="submit"
            onClick={handleSubmit}
          >
            Submit
          </button>
        </div>
      )}
    </form>
  );
};

export default Choice;
